<template>
    <div>
        <div style="display: inline-block;width: 100%;">
            <span class="label_title">{{ parentMessage }}</span>
            <span @click="back" style="float: right;cursor: pointer;color: #409EFF;" v-if="showback">返回 <i class="el-icon-arrow-right"></i></span>
        </div>
        
        <el-divider></el-divider>
    </div>
</template>
<script>
export default {
    name:'Titlelabel',
    props:{
        parentMessage:{
            type:String
        },
        showback:{
            type:Boolean
        }
        
    },
    methods:{
        back(){
            this.$router.back();
        }
    }
}
</script>
<style lang="less" scoped>

.label_title{
    float: left;
    text-indent: 10px;
    border-left: 3px #409EFF solid;
    font-weight: 700;
}
</style>